import { Adapter } from '@fmnts/core';
import { InlineTranslateable } from '@fmnts/i18n';

import { CampaignPage, CampaignPageAdapter } from './campaign-page';

export class FeedbackForm {
  constructor(
    public id: string,
    public headerImage: InlineTranslateable | undefined,
    public organizationLogo: string | undefined,
    public fundraiserImage: string | undefined,
    public fundraiserName: string,
    public fundraiserRole: string | undefined,
    public form: CampaignPage,
    public language: string,
    public locale: string,
    public hash: string,
    public style: string,
  ) {}
}

export class FeedbackFormAdapter implements Adapter<FeedbackForm> {
  constructor(private pageAdapter = new CampaignPageAdapter()) {}

  adapt(item: Record<string, any>): FeedbackForm {
    return new FeedbackForm(
      item['id'],
      item['header_image'],
      item['organizationLogo'],
      item['fundraiser_image'],
      item['fundraiser_name'],
      item['fundraiser_role'],
      this.pageAdapter.adapt(item['form']),
      item['language'],
      item['locale'],
      item['hash'],
      item['style'],
    );
  }
}
